function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Menu, MenuDivider, MenuItem, MenuList, Portal, Spinner } from '@chakra-ui/react';
import { faCog, faPencil, faPlus, faPowerOff, faShuffle, faTrash, faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
function SongSettingsMenu(_param) {
    var songRequestEnabled = _param.songRequestEnabled, _param_isShuffling = _param.isShuffling, isShuffling = _param_isShuffling === void 0 ? false : _param_isShuffling, onShuffle = _param.onShuffle, onAddPlaylistItem = _param.onAddPlaylistItem, onAddSongRequest = _param.onAddSongRequest, toggleSongRequestEnabled = _param.toggleSongRequestEnabled, onClearQueue = _param.onClearQueue, onClearPlaylist = _param.onClearPlaylist, onEditSettings = _param.onEditSettings, onImportPlaylist = _param.onImportPlaylist, onEditPlaylist = _param.onEditPlaylist, props = _object_without_properties(_param, [
        "songRequestEnabled",
        "isShuffling",
        "onShuffle",
        "onAddPlaylistItem",
        "onAddSongRequest",
        "toggleSongRequestEnabled",
        "onClearQueue",
        "onClearPlaylist",
        "onEditSettings",
        "onImportPlaylist",
        "onEditPlaylist"
    ]);
    return /*#__PURE__*/ _jsxs(Menu, _object_spread_props(_object_spread({
        size: "sm",
        closeOnSelect: false,
        placement: "bottom-end"
    }, props), {
        children: [
            props.children,
            /*#__PURE__*/ _jsx(Portal, {
                children: /*#__PURE__*/ _jsxs(MenuList, {
                    children: [
                        /*#__PURE__*/ _jsx(MenuItem, {
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faCog
                            }),
                            onClick: onEditSettings,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "D3idYv",
                                defaultMessage: "Settings"
                            })
                        }),
                        onEditPlaylist != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            onClick: onEditPlaylist,
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faPencil
                            }),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "sFXDWG",
                                defaultMessage: "Manage Playlist"
                            })
                        }) : null,
                        /*#__PURE__*/ _jsx(MenuDivider, {}),
                        onAddSongRequest != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            onClick: onAddSongRequest,
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faPlus
                            }),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "AcTvIK",
                                defaultMessage: "Request Song"
                            })
                        }) : null,
                        onClearQueue != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faTrash
                            }),
                            onClick: onClearQueue,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "qfajZz",
                                defaultMessage: "Clear Queue"
                            })
                        }) : null,
                        onAddPlaylistItem != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            onClick: onAddPlaylistItem,
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faPlus
                            }),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "Fgv+B2",
                                defaultMessage: "Add Song"
                            })
                        }) : null,
                        onImportPlaylist != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faCloudDownload
                            }),
                            onClick: onImportPlaylist,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "8kO91X",
                                defaultMessage: "Import Playlist"
                            })
                        }) : null,
                        onShuffle != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            onClick: onShuffle,
                            icon: isShuffling ? /*#__PURE__*/ _jsx(Icon, {
                                as: Spinner
                            }) : /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faShuffle
                            }),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "bo6ksH",
                                defaultMessage: "Shuffle Playlist"
                            })
                        }) : null,
                        onClearPlaylist != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faTrash
                            }),
                            onClick: onClearPlaylist,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "t4NH/j",
                                defaultMessage: "Clear Playlist"
                            })
                        }) : null,
                        toggleSongRequestEnabled != null ? /*#__PURE__*/ _jsx(MenuItem, {
                            icon: /*#__PURE__*/ _jsx(Icon, {
                                as: FontAwesomeIcon,
                                icon: faPowerOff
                            }),
                            onClick: toggleSongRequestEnabled,
                            children: songRequestEnabled === true ? /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "nD1Dyq",
                                defaultMessage: "Disable Requests"
                            }) : /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "MrWPt/",
                                defaultMessage: "Enable Requests"
                            })
                        }) : null
                    ]
                })
            })
        ]
    }));
}
export default SongSettingsMenu;
